import Vue from 'vue'
import {saveAs} from 'file-saver';

Vue.prototype.$http = window.axios
var focusTimeout = null

const getItemElement = (itemNumber)=>{
    const node = document.getElementById('item_'+itemNumber);
    return node;
}
const getParentOfItemNumber = (itemNumber)=>{
    const itemNumberArray = itemNumber.split('.');
    itemNumberArray.pop();
    return itemNumberArray.length>= 1? itemNumberArray.join('.'): null 
}

export default new Vue({
  data: {
      loggedInUser:{},
      checkVisibility:false,
      reviewTreePlayer:null,
      reviewTreeItem:null,
      indexPath:[],
      refreshStatus: false,
      lastUpdateId: "",
      currentIndexMT:-1,
      unsavedChangesInRoot:{},
      saveChangesMT:false,
      instanceMT:"",
      instances:[],
      loadCount:0,
      openedDialog:[],
      dialogsMissingTranslation:[],
      checkTranslationPhrases:{},
      dialogsMissingTranslationCount:0,
      uniquedialogsMissingTranslationCount:0,
      dialogCounter:0,
      lastPhraseUpdated:{},
      dialogsMT:{},
      phrasesMT:{},
      secondaryLanguageMT:"",
      inspectionViewMT:false,
      dialogsItemNumber:{}, 
      paragraphPhrases: [],
      currentDialog: {},
      deleteRoot: false,
      dialogTreeSearch: false,
      startTagId:"",
      currentDialogParentList:[],
      dialogs: {},
      showAuthorisationView: false,
      statusinit:false,
      uploadDialogVidCursor:"",
      newguidVid: "",
      videoGalleryStatus: false,
      uploadVideoAttachment:[],
      galleryVideoId:"",
      instructionVidselected:false,
      uploadDialogtreeVid:[],
      instructionVid:[],
      instructionSelected:false,
      instructionImgselected:false,
      newguidImg:"",
      galleryimageId:"",
      uploadImgAttachment:[],
      dialogTreeGalleryStatus:false,
      uploadDialogImgCursor:"",
      uploadDialogtreeImg:[],
      instructionImg:[],
      languages: [],
      preferredLanguage: null,
      token: null,
      claims: {
          phrases: 0,
          languages: 0,
          users: 0,
          dialogs: 0,
          settings: 0
      },
      phrases: [],
      users: [],
      dialogHasImage: {},
      showUploadImageDialog: false,
      answerImageUploadDialog: false,
      currentDialogId: '',
      changeDeleteImage: false,
      changeDeleteVideo: false,
      dialogHasAttachment: {},
      uploadDialogImgSrc: '',
      uploadDialogVidSrc: '',
      moveDialog: false,
      draggedDialog: {},
      undoStack: [],
      dialogRef: {},
      dialogParent: {},
      reorder: false,
      imageChosen: false,
      videoChosen: false,
      linkChosen: false,
      uploadingInstructionImage: false,
      instructionAttachments:{},
      instructionImages: {},
      instructionImagesId: {},
      editingInstImg: false,
      editingInstImgIndex: 0,
      instructionVideos: {},
      instructionVideosId: {},
      editingInstVid: false,
      editingInstVidIndex: 0,
      instructionVideoLinks: {},
      instructionVideoLinksId: {},
      instructionVideoLinks: {},
      instructionVideoLinksId: {},
      languageFlagExist: {},
      languageFlagSrc: {},
      showUploadFlagDialog: false,
      currentLanguageId: "",
      limit: 500,
      phrasesLoaded: false,
      currentDialogRef:null,
      langDict:{},
      searchState: false,
      showDialogInstanceView: false,
      currentDialogIdForInstanceView:"",
      wordsMissingTranslationCount: 0,
      uniqueWordsMissingTranslationCount: 0,
      uniqueArr:[],
      uniquePhrasesMissingIds: [],
      missingDialogParent: {}, 
      missingDialogIdMapping: {},
      itemNumberArray: [],
      dynamicVideoLanguageItems: {},
      dynamicVideoLanguageLoaded: false,
      translatedPhraseIds: [],
  },
  watch: {
    'token': function(newToken) {
        if (newToken) {
            if (this.claims.users & 1) { this.getUsers() }
        }
     }
  },
  methods: {
    downloadQR(instanceName){
        this.$http.post('/auth/qrinstance', null, {
            headers: {
                instance: instanceName
            },
            responseType: 'blob'
        }).then((res)=>{
            saveAs(URL.createObjectURL(res.data),`${instanceName}-qrCode.jpg`)
        })
    },
    addtranslatedphrase(id) {
        this.translatedPhraseIds.push(id);
    },
      undo(e) {
          if (this.undoStack.length) {
              e.preventDefault();
              var elem = this.undoStack[this.undoStack.length - 1];
              if (elem.type === "copy") {
                  if (this.dialogRef[elem.replicated])
                      this.dialogRef[elem.replicated].deleteRootDialog();
                  this.undoStack.pop();
              }
          }
      },
      setItemNumber(id, itemNumber, mutatedParentId){
        if(this.dialogsItemNumber[id]){
            this.dialogsItemNumber[id].push(itemNumber)
        }else{
            this.dialogsItemNumber[id] = [itemNumber];
        }
        this.missingDialogParent[itemNumber] = mutatedParentId;
      },
      setCurrentIndex(index){
        this.currentIndexMT = index;
      },
      move(direction,refStep) {
        refStep = !(isNaN(refStep)) ? refStep: this.currentIndexMT;
        const newIndex = refStep + direction;
        if (newIndex < 0) {
            if(newIndex === -1){
                this.currentIndexMT = 0;
            }else{
                this.currentIndexMT = this.dialogsMissingTranslationCount - 1;

            }
        }else if (newIndex >= this.dialogsMissingTranslationCount) {
            this.currentIndexMT = 0;
          }else{
              this.currentIndexMT = newIndex;
          }
        
    
        var id = this.itemNumberArray[this.currentIndexMT];
        var highlighted = document.querySelectorAll(".highlight") || [];
        var i;
        for (i = 0; i < highlighted.length; i++) {
        
          highlighted[i] && highlighted[i].classList.remove("highlight");
        }
        var el = getItemElement(id);
        if(el){
            el.classList.add('highlight');
            this.focusOnDialog(id);
        }else{
            setTimeout(()=>{
                var el = getItemElement(id);
                el.classList.add('highlight');
                this.focusOnDialog(id);
            },100);
        }
      },
      focusOnDialog(id){
        var el = getItemElement(id);
        const parentOpen = el ? el.getAttribute('data-parent-open') : null;
        if(el!== null &&parentOpen ){
            setTimeout(()=>{
                el.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                });
            }, 0);
            
        }else{
            setTimeout(()=>{
                let parentId = getParentOfItemNumber(id);
                let parentEl;
                while(parentId){
                 parentEl = getItemElement(parentId)
                    if(parentEl){
                        parentId = getParentOfItemNumber(parentId);
                        const parentOpen = parentEl.getAttribute('data-open');
                        const grandParentOpen = parentEl.getAttribute('data-parent-open');
                        if(grandParentOpen && !parentOpen){
                            parentId = undefined;
                        }
                    }else{
                        parentId = getParentOfItemNumber(parentId);
                    }
                }
                parentEl && parentEl.click();
                focusTimeout = setTimeout(()=>{
                    const dialogEl = getItemElement(parentId);
                    if(dialogEl){
                        dialogEl.scrollIntoView({
                            behavior: "smooth",
                            block: "center",
                        });
                        }  
                }, 1000);
            },100);
        }
      },
      findIncompleteDialogs() {
        var arr = [];
        var arrID = {};
        var dialogsMissingTranslation = [];
        var dialogsMissingTranslationCount = 0;
        var translatedPhraseIds = new Set();
        var untranslatedPhraseIds = new Set();
        var dialogIds = new Set();
        for (var dID in this.checkTranslationPhrases) {
            const phrase = this.checkTranslationPhrases[dID];
            var foundTranslation = phrase.translations.filter(
                (t) => t.language === this.preferredLanguage
            )[0];
            if (
                !foundTranslation &&
                dialogsMissingTranslation.indexOf(dID) < 0
            ) {
                var arrayOfItemNumber = this.dialogsItemNumber[dID];
                const map = {};
                untranslatedPhraseIds.add(phrase.id);
                dialogIds.add(dID);
                for(let i=0;i<arrayOfItemNumber.length;i++){
                    const itemNumber = arrayOfItemNumber[i];
                    if(!(itemNumber in map)){
                        map[itemNumber] = 1;
                        arr.push(itemNumber);
                        arrID[itemNumber] = dID;
                    }
                }
            }else{
                translatedPhraseIds.add(phrase.id);
            }
        }
        arr = arr
          .sort((a,b)=>sortNumberWithPointerValue(a,b))
        const idMappingWithIndex = {};
        arr.forEach((itemNumber,index) => {
            dialogsMissingTranslationCount++;
           dialogsMissingTranslation.push(arrID[itemNumber]+"_"+itemNumber);
           idMappingWithIndex[arrID[itemNumber]+"_"+itemNumber] = index;
        });
        this.itemNumberArray = arr;
        this.dialogsMissingTranslationCount = dialogsMissingTranslationCount;
        this.dialogsMissingTranslation = dialogsMissingTranslation
        this.missingDialogIdMapping = idMappingWithIndex;
        this.uniqueArr = Array.from(dialogIds);
        this.uniquePhrasesMissingIds = Array.from(untranslatedPhraseIds)

    },
      moveToItem(itemNumber){
        const itemIndex = this.itemNumberArray.findIndex((i)=>i===itemNumber);
        if(itemIndex !== -1 ){
            this.move(0, itemIndex);
        }else{
            const newIndex = [...this.itemNumberArray, itemNumber].sort((a,b)=>sortNumberWithPointerValue(a,b)).findIndex((i)=>i===itemNumber);
            if(newIndex < this.itemNumberArray.length){
                this.move(0, newIndex);
            }else{
                this.move(0,0);
            }
        }
      },
      /**
       * Fetches all languages and populates the store with them
       */
      getLanguages() {
          this.$http
              .get('/languages')
              .then(response => {
                  if (response.data) {
                      this.languages = response.data
                      if (this.languages.length > 0) {
                          this.preferredLanguage = this.languages[0].id
                      }
                      this.checkLanguageAttachment();
                  }
              })
        },
        checkLanguageAttachment() {
            var lang = this.languages;
            lang.forEach(language => {
                    return new Promise((resolve, reject) => {
                    this.$http
                        .get("languages/" + language.id + "/attachment", {    
                            responseType: "arraybuffer"
                        })
                        .then(response => {
                            this.$set(this.languageFlagExist, language.id, true);
                            let image = btoa(
                                new Uint8Array(response.data).reduce(
                                    (data, byte) => data + String.fromCharCode(byte),
                                    ""
                                )
                            );
                            var langImg = `data:${response.headers[
                "content-type"
              ].toLowerCase()};base64,${image}`;
                            this.$set(this.languageFlagSrc, language.id, langImg);
                            resolve(response)
                        }).catch((response) =>{ 
                            resolve(response)
                        })
            })
        })
        },
        /**
         * Adds a language to store
         * @param {object} language The language to be added
         */
        addLanguage(language) {
            this.languages.push(language)
            if (this.languages.length === 1) {
                this.preferredLanguage = language.id
            }
        },
        /**
         * Removes a language from store (not backend)
         * @param {string} id ID of language to remove
         */
        deleteLanguage(id) {
            this.languages = this.languages.filter(x => x.id !== id)
            if (this.preferredLanguage === id) {
                this.preferredLanguage = this.languages[0]
            }
        },
        /**
         * Fetch all phrases and populate store with them
         */
        getPhrases() {
            return new Promise((resolve, reject) => {
                this.phrases.length = 0;
                this.phrasesLoaded = false;
                var cursorID = "";
                this.getPhrasesLimited(cursorID).then(() => {
                    if (this.phrasesLoaded) {
                        resolve()
                    } else {
                        reject(Error("Couldn't fetch phrases"))
                    }
                }).catch(() => {
                    reject(Error("Couldn't fetch phrases"))
                })
            })
        },

        getPhrasesLimited(cursor) {
            return this.$http.get('/phrases?limit=' + this.limit + '&cursor=' + cursor).then(response => {
                cursor = response.data.Cursor;
                this.$store.phrases = this.$store.phrases.concat(response.data.List);
                if (response.data && response.data.List && response.data.List.length == 0) {
                    this.$store.phrasesLoaded = true
                    this.$http.delete('/phrases?cursor=' + cursor)
                } else if (response.data.length == 0) {
                    this.$store.phrasesLoaded = true
                }
                if (!this.$store.phrasesLoaded) {
                    return this.getPhrasesLimited(cursor)
                }
            }, )
        },

        /**
         * Post a new phrase to backend
         * @param {object} phrase Phrase to post
         */
        postPhrase(phrase) {
            return new Promise((resolve, reject) => {
                this.$http.post('/phrases', JSON.stringify(phrase)).then(
                    response => {
                        this.phrases.push(phrase)
                        resolve(response.data.id)
                    },
                    response => {
                        reject(response)
                    }
                )
            })
        },
        /**
         * Put a new phrase to backend
         * @param {object} phrase Phrase to put
         */
        putPhrase(phrase) {
            return new Promise((resolve, reject) => {
                this.$http.put('/phrases/' + phrase.id, phrase).then(
                    response => {
                        const i = this.phrases.findIndex(p => p.id === phrase.id)
                        this.$set(this.phrases, i, phrase)
                        resolve(response)
                    },
                    response => {
                        reject(response)
                    }
                )
            })
        },
        /**
         * Put translation to backend phrase that works with multiple translators
         * editing different languages in same phrase.
         * @param {string} phraseID
         * @param {object} translation
         */
        putTranslation(phraseID, translation) {
            var put = this.putPhrase
            return new Promise((resolve, reject) => {
                this.$http.get('/phrases/' + phraseID).then(
                    response => {
                        var p = response.data
                        var oldTranslation = p.translations ? p.translations.filter(t => t.language === translation.language)[0] : undefined;
                        if (typeof oldTranslation === "undefined") {
                            oldTranslation = {
                                text: "",
                                language: translation.language,
                            }
                            p.translations.push(oldTranslation)
                        }
                        oldTranslation.text = translation.text
                        return p
                    },
                    response => {
                        reject(response)
                    }
                ).then(function(result) {
                    put(result).then(
                        response => {
                            resolve(result)
                        },
                        response => {
                            reject(response)
                        }
                    )
                })
            })
        },
        /**
         * Get a dialog by id
         * @param {string} dialog id to get
         */
        getDialogById(dialogID) {
            return new Promise((resolve, reject) => {
                if (dialogID == "") {
                    reject("Cannot get dialog with null id")
                } else {
                    return this.$http.get('/dialogs/' + dialogID).then(
                        response => {
                            resolve(response.data)
                        }
                    )
                }
            })
        },

        /**
         * Post a new dialog to backend
         * @param {object} dialog Dialog to post
         */
        postDialog(dialog) {
            return new Promise((resolve, reject) => {
                this.$http.post('/dialogs', dialog).then(
                    response => {
                        resolve(response.data)
                    },
                    response => {
                        reject(response)
                    }
                )
            })
        },
        postDialogLocally(dialog) {
            return new Promise((resolve, reject) => {
                this.$http.post("dialogs", dialog).then(
                    response => {
                        resolve(response.data)
                    },
                    response => {
                        reject(response)
                    }
                )
            })
        },
        /**
         * Put a new dialog to backend
         * @param {object} dialog Dialog to put
         */
        putDialog(dialog) {
            return new Promise((resolve, reject) => {
                this.$http.put('/dialogs/' + dialog.id, dialog).then(
                    response => {
                        resolve(response.data)
                    },
                    response => {
                        reject(response)
                    }
                )
            })
        },
        putDialogLocally(dialog) {    
            return new Promise((resolve, reject) => {
                this.$http.put('/dialogs/'+dialog.id + "/local", dialog).then(
                    response => {
                        resolve(response.data)
                    },
                    response => {
                        reject(response)
                    }
                )
            })
        },
        /**
         * Delete a dialog
         * @param {int} id The ID of the dialog to be deleted
         */
        deleteDialog(id) {
            return new Promise((resolve, reject) => {
                this.$http.delete('/dialogs/' + id).then(
                    response => {
                        resolve()
                    },
                    response => {
                        reject(response)
                    }
                )
            })
        },
        getUsers() {
            return new Promise((resolve, reject) => {
                this.$http
                    .get('/auth/users')
                    .then(r => {
                        this.users = r.data
                        resolve(this.users)
                    })
                    .catch(r => {
                        reject(r)
                    })
            })
        },
        /**
         * Change dialog search state to OFF in backend
         */
         postDialogSearchState(dialogId) {
            return new Promise((resolve, reject) => {
                this.$http.post('/search/indexdialog/' + dialogId).then(
                    response => {
                        resolve(response.data)
                    },
                    response => {
                        reject(response)
                    }
                )
            })
        },
        /**
         * Change dialog search state to ON in backend
         */
        deleteDialogSearchState(dialogId) {
             return new Promise((resolve, reject) => {
                this.$http.delete('/search/indexdialog/' + dialogId).then(
                    response => {
                        resolve(response.data)
                    },
                    response => {
                        reject(response)
                    }
                )
            })
         },
         /**
          * dvl api is for coordinating the merging of audio from hri with videos
          */
         getAllDynamicVideoLanguageItems() {
            console.log("get dvl");
            this.$http.get('/dialogs/0/dynamicVideoLanguage').then(
                response => {
                    console.log("get dvl:",response);
                    for (var i of response.data) {
                        console.log("get dvl, i:",i);
                        //this.$set(this.dynamicVideoLanguageItems,i.DialogID, i);
                        this.dynamicVideoLanguageItems[i.DialogID] = i;
                    }
                    console.log("get dvl:",this.dynamicVideoLanguageItems);
                    this.dynamicVideoLanguageLoaded = true;
                    return this.dynamicVideoLanguageItems;
                },
                response => {
                    console.log("get dvl:",response);
                    return response;
                }
            )
         }
    },

    /**
     * Computed data-properties.
     * These are cached by Vue until changes are made to source data
     */
    computed: {
        autocompletePhrases: function() {
            var values = {}
            this.phrases.forEach(p => {
                const primaryTranslation = p.translations ? p.translations.filter(t => t.language === this.preferredLanguage) : [];
                if (primaryTranslation.length > 0) {
                    values[primaryTranslation[0].text] = null
                }
            })
            return values
        },
        userID: function() {
            const base64Url = this.token.split('.')[1]
            const base64 = base64Url.replace('-', '+').replace('_', '/')
            return JSON.parse(atob(base64)).id
        }
    }
})

const sortNumberWithPointerValue = (a, b)=>{
    const n = a.split('.').map((a)=>parseInt(a)); // 1.2.3.4 => ["1","2","4","5"]
    const m = b.split('.').map((b)=>parseInt(b));
    let index = 0;
    while(true){
        if(n[index] !=undefined && m[index] != undefined){
            if(n[index] === m[index]){
                index++;
            }else if(n[index] > m[index]){
                return 1;
            }else{
                return -1;
            }
        }else{
            if(n[index]){
                return 1;
            }
            if(m[index]){
                return -1;
            }else{
                return 0;
            }
        }
    }
}